import {
    GET_MONTHLY_COLLECTIONS_SUMMARY_REQUEST,
    GET_MONTHLY_COLLECTIONS_SUMMARY_SUCCESS,
    GET_MONTHLY_COLLECTIONS_SUMMARY_FAIL,
    GET_MONTHLY_COLLECTIONS_SUMMARY_RESET,
    GET_MONTHLY_RECOVERY_COLLECTIONS_REQUEST,
    GET_MONTHLY_RECOVERY_COLLECTIONS_SUCCESS,
    GET_MONTHLY_RECOVERY_COLLECTIONS_FAIL,
    GET_MONTHLY_RECOVERY_COLLECTIONS_RESET,
    GET_MONTHLY_FLOW_COLLECTIONS_REQUEST,
    GET_MONTHLY_FLOW_COLLECTIONS_SUCCESS,
    GET_MONTHLY_FLOW_COLLECTIONS_FAIL,
    GET_MONTHLY_FLOW_COLLECTIONS_RESET,
} from '../constants/monthlyMisConstants'

export const getMonthlyCollectionsSummaryReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_MONTHLY_COLLECTIONS_SUMMARY_REQUEST:
            return { loadingMonthlyCollectionsSummary: true }
        case GET_MONTHLY_COLLECTIONS_SUMMARY_SUCCESS:
            return {
                loadingMonthlyCollectionsSummary: false,
                monthlyCollectionsSummaryData: action.payload,
            }
        case GET_MONTHLY_COLLECTIONS_SUMMARY_FAIL:
            return {
                loadingMonthlyCollectionsSummary: false,
                errorMonthlyCollectionsSummary: action.payload,
            }
        case GET_MONTHLY_COLLECTIONS_SUMMARY_RESET:
            return {}
        default:
            return state
    }
}

export const getMonthlyRecoveryCollectionsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_MONTHLY_RECOVERY_COLLECTIONS_REQUEST:
            return { loadingMonthlyRecoveryCollections: true }
        case GET_MONTHLY_RECOVERY_COLLECTIONS_SUCCESS:
            return {
                loadingMonthlyRecoveryCollections: false,
                monthlyRecoveryCollectionsData: action.payload,
            }
        case GET_MONTHLY_RECOVERY_COLLECTIONS_FAIL:
            return {
                loadingMonthlyRecoveryCollections: false,
                errorMonthlyRecoveryCollections: action.payload,
            }
        case GET_MONTHLY_RECOVERY_COLLECTIONS_RESET:
            return {}
        default:
            return state
    }
}

export const getMonthlyFlowCollectionsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_MONTHLY_FLOW_COLLECTIONS_REQUEST:
            return { loadingMonthlyFlowCollections: true }
        case GET_MONTHLY_FLOW_COLLECTIONS_SUCCESS:
            return {
                loadingMonthlyFlowCollections: false,
                monthlyFlowCollectionsData: action.payload,
            }
        case GET_MONTHLY_FLOW_COLLECTIONS_FAIL:
            return {
                loadingMonthlyFlowCollections: false,
                errorMonthlyFlowCollections: action.payload,
            }
        case GET_MONTHLY_FLOW_COLLECTIONS_RESET:
            return {}
        default:
            return state
    }
}